<div class="container-content">
  <app-provider-header [welcomeText]="welcomeText" [supportText]="supportText" [imagePath]="imagePath"></app-provider-header>

  <div class="p-grid p-fluid onboarding-heading">
    <div class="p-col-12 p-md-12 p-lg-12 text-center">
      Thank you for uploading!
    </div>
  </div>

</div>
